import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Typography } from "antd";
import { Card, Badge, Spin } from "antd";
import { getAge } from "../../lib/utils";
import { useUserData } from "../../hooks/useUsers";
import Request from "./Request";

const { Meta } = Card;
const { Text } = Typography;

export default function Interest({ disableButtons, userId }) {
  let navigate = useNavigate();
  const { loading, userData } = useUserData(userId);

  React.useEffect(() => {
    if (loading) return;
    if (userData && !userData.profileCompleted) {
      navigate('/onboarding');
    } else {
      return
    }
  }, [userData, loading, navigate]);

  return (
    loading ? (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
      </div>
    ) : userData && (
      <div style={{ marginBottom: '20px' }}>
        <Link to={`/profile-page/${userData?.uid}`} style={{ textDecoration: 'none' }}>
          <Badge.Ribbon
            text={`${getAge(userData?.dateOfBirth)} yrs`}
            color="#667eea"
            style={{ 
              fontSize: '12px',
              fontWeight: '600'
            }}
          >
            <Card
              hoverable
              style={{
                borderRadius: '16px',
                overflow: 'hidden',
                border: 'none',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)'
              }}
              bodyStyle={{ padding: '16px' }}
              cover={
                <div style={{ 
                  overflow: "hidden", 
                  height: "240px",
                  position: 'relative'
                }}>
                  <img
                    alt={userData?.firstName}
                    style={{ 
                      height: "100%", 
                      width: "100%",
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    src={userData?.profileImages[0]?.url}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(transparent, rgba(0,0,0,0.6))',
                    height: '60px'
                  }} />
                </div>
              }
            >
              <Meta 
                title={
                  <span style={{ 
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#2c3e50'
                  }}>
                    {userData?.firstName} {userData?.lastName}
                  </span>
                } 
              />
              <Text style={{ 
                fontSize: '13px',
                color: '#64748b',
                lineHeight: '1.4',
                marginTop: '8px',
                display: 'block'
              }}>
                {userData?.gender} • {userData?.maritalStatus} • {userData?.subCaste}
              </Text>
              <Text style={{ 
                fontSize: '13px',
                color: '#64748b',
                lineHeight: '1.4'
              }}>
                {userData?.education} • {userData?.currentResidence}
              </Text>
            </Card>
          </Badge.Ribbon>
        </Link>
        {!disableButtons && (
          <div style={{ marginTop: '12px' }}>
            <Request key={userId} id={userId} />
          </div>
        )}
      </div>
    )
  );
}